module.exports = __webpack_public_path__ + "static/media/effah.0a117a96.webp";